import React from "react";
import {
  withRouter,
  Route,
  Switch,
  BrowserRouter as Router,
} from "react-router-dom";
import { connect } from "react-redux";

import "./custom.css";
import "./App.scss";
import { LoginCallback, Security } from "@okta/okta-react";
import oktaAuth from "./lib/oktaInstance";
import BaseRoutes from "./components/BaseRoutes";

const App = (props) => {
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    window.location = originalUri || "/dashboard";
  };

  return (
    <React.Fragment>
      <Router>
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <Switch>
            <Route path="/login/callback" component={LoginCallback} />
            <BaseRoutes />
            <Route path="*" component={NotFound} />
          </Switch>
        </Security>
      </Router>
    </React.Fragment>
  );
};

const NotFound = () => {
  return <div>Not found</div>;
};

const mapStatetoProps = (state) => {
  const { user } = state.User;
  return { user };
};

export default withRouter(connect(mapStatetoProps)(App));
